import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ptBR } from 'date-fns/locale';

export default function DatePickerFim({ fim, setFim, inicio, label }: { fim: number | Date | null, setFim: Function, inicio: number | Date | null, label: string }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
      <DesktopDatePicker
        format='dd/MM/yyyy'
        yearsPerRow={3}
        label={label}
        value={fim ? new Date(fim) : null}
        minDate={inicio ? new Date(inicio as number) : undefined}
          onChange={(newValue) => {
          if (!newValue) return setFim(null);
          const date = new Date(newValue.getTime());
          date.setHours(23, 59, 59, 59);
          setFim(date);
        }}
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
          field: {
            readOnly: true,
          },
        }}
        localeText={{
          clearButtonLabel: 'Limpar',
        }}
      />
    </LocalizationProvider>
  );
}
